import React, { Component } from "react"
import { text } from "../../attributes/items/primitives"

import styled from "react-emotion"

import Input from "ui/components/Input"
import { Section } from "ui"
import { Container } from "ui"
import Card from "ui/components/Card"
import Button from "ui/components/Button"
import Text from "ui/components/Text"

import { LoginApi } from "features/auth/utils"
import { withRouter } from "react-router"

/**
 * @augments {Component<BlockTypeProps, {value: string}>}
 */
class LoginBlocktype extends Component {
    state = {
        value: "",
    }
    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => (
                    <LoginPanel>
                        <Section margin="small" padding="none">
                            <LoginInput
                                onChange={e => this.setState({ email: e.target.value })}
                                padding="medium"
                                placeholder="Email"
                            />
                        </Section>
                        <Section margin="small" padding="none">
                            <LoginInput
                                type="password"
                                onChange={e => this.setState({ password: e.target.value })}
                                padding="medium"
                                placeholder="Password"
                            />
                        </Section>
                        <Container margin="none" padding="none" style={{ width: "100%" }}>
                            <LoginButton
                                onClick={() => this.login(attrs.link)}
                                margin="medium"
                                color="success"
                            >
                                {attrs.label || "Log in"}
                            </LoginButton>
                        </Container>
                        <Container>
                            <Text style={{ color: "red" }}>
                                &nbsp;{" "}
                                {this.state.error &&
                                    (attrs.errorMessage ||
                                        "Please check your username and password")}
                            </Text>
                        </Container>
                    </LoginPanel>
                )}
            </Wrapper>
        )
    }
    login = link => {
        LoginApi.auth_end_user(this.state.email, this.state.password).then(response => {
            let token = response.api_token
            if (!token) {
                this.setState({ error: true })
                return
            }

            localStorage.setItem("user_token", token)
            localStorage.setItem("user", JSON.stringify(response))
            this.props.router.push(link || "/")
        })
    }
}

LoginBlocktype.attributes = [
    text({ field: "link", label: "Page after successful login" }),
    text({ field: "label", label: "Button Label" }),
    text({ field: "errorMessage", label: "Error Message" }),
]

export default withRouter(LoginBlocktype)

const LoginButton = styled(Button)`
    width: 300px;
`

const LoginInput = styled(Input)`
    width: 300px;
`

const LoginPanel = styled("div")`
    width: 100%;

    text-align: center;
    margin: 10% auto;
    padding: 10%;
    align-items: center;
`

// const SocialButton = SocialLogin(({ children, triggerLogin, ...props }) => (
//     <button onClick={triggerLogin} {...props}>
//         {children}
//     </button>
// ))

// const handleSocialLogin = user => {
//     console.log(user)
// }

// const handleSocialLoginFailure = err => {
//     console.error(err)
// }



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/LoginBlock.js